import { useState, useEffect } from "react";
import axios from "axios";
import { MessageCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WhatsAppButton = () => {
  const [whatsappNumber, setWhatsappNumber] = useState("94752403070");
  const message = "Hello! I'm interested in studying abroad. Can you help me?";

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        if (response.data?.whatsapp_number) {
          // Remove non-digits from the phone number
          setWhatsappNumber(response.data.whatsapp_number.replace(/\D/g, ''));
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
    fetchSettings();
  }, []);
  
  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message);
    // Try wa.me first (works on mobile and desktop with WhatsApp Web)
    const webUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.location.href = webUrl;
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform whatsapp-pulse cursor-pointer border-none outline-none"
      data-testid="whatsapp-button"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-8 h-8 text-white fill-white" />
    </button>
  );
};

export default WhatsAppButton;
